import { FormGroup, Input, Label } from 'reactstrap';
import './styles.css';
import { Link, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import DefaultButton from '../../components/Buttons/Default';
import { useAuth } from '../../context/auth';
import { toast, ToastContainer } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { post } from '../../utils/helpers/api';
import { useSettings } from '../../context/settings';

function LoginPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { updateSettings } = useSettings();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { handleLogin, isLoggedIn } = useAuth();

  useEffect(() => {
    if (isLoggedIn) {
      navigate('/home');
    }
  }, [isLoggedIn, navigate]);

  // Why the session ended, left behind by the API helper when it sent us back here.
  useEffect(() => {
    const reason = localStorage.getItem('session_error');

    if (reason) {
      localStorage.removeItem('session_error');
      toast.error(t(reason));
    }
  }, [t]);

  const login = async () => {
    setLoading(true);
    const data = await post('/login', { email, password });
    if (data && data.success) {
      /**
       * Credentials are fine but the account reaches no branch, so every screen
       * behind this one would answer 409. Stopping here says so once, instead of
       * letting the app in and bouncing it straight back out.
       */
      if (!(data.branches ?? []).length) {
        toast.error(t('errors.noBranchAvailable'));
        setLoading(false);
        return;
      }

      handleLogin(data);
      updateSettings(data.company_settings);
      navigate('/home');
    } else {
      toast.error(t('auth.loginFailed'))
    }
    setLoading(false);
  }

  return(
    <main className="auth-page">
      <div className="auth-container">
        <div className="login-card">
          <div className="login-header">
            <h2 className="login-title">{t('auth.welcomeBack')}</h2>
            <p className="login-subtitle">{t('auth.signIn')}</p>
          </div>

          <FormGroup>
            <Label>{t('auth.emailAddress')}</Label>
            <Input
              name="email"
              type="email"
              placeholder={t('auth.emailPlaceholder')}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </FormGroup>

          <FormGroup>
            <Label>{t('auth.password')}</Label>
            <Input
              name="password"
              type="password"
              placeholder={t('auth.passwordPlaceholder')}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </FormGroup>

          <div className="form-options">
            <div className="form-check">
              <Input className="form-check-input" type="checkbox" id="remember" />
              <Label className="form-check-label" for="remember">
                {t('auth.rememberMe')}
              </Label>
            </div>
            <Link to="/password/email" className="forgot-link">{t('auth.forgotPassword')}</Link>
          </div>

          <DefaultButton
            block
            onClick={login}
            loading={loading}
            disabled={!email || password?.length < 8 || loading}
          >
            {t('auth.signInBtn')}
          </DefaultButton>

          <div className="auth-footer">
            {t('auth.footer')}
          </div>
        </div>
      </div>

      <ToastContainer
        pauseOnFocusLoss={false}
        pauseOnHover={false}
        autoClose={3000}
        position="top-center"
      />
    </main>
  );
}

export default LoginPage;
